import React, { Component } from 'react';
import Fade from 'react-reveal';
import { connect } from 'react-redux';
import reasonSick from './../../shared/assets/images/covid/reason-sick.png';
import reasonAccident from './../../shared/assets/images/covid/reason-accident.png';
import reasonBusiness from './../../shared/assets/images/covid/reason-business.png';
import reasonVocation from './../../shared/assets/images/covid/reason-vocation.png';
import lang from '../../lang/lang.json';
import './howToGet.scss';

class HowToGet extends Component {
  constructor(props) {
    super(props);

    this.state = {
      onSelectCityHandler: '',
      isMobile: false,
    };
  }
  componentDidMount() {
    if (window.innerWidth <= 768) {
      this.setState({
        isMobile: true,
      });
    }
  }

  componentWillReceiveProps(props) {
    this.setState({
      onSelectCityHandler: props.cityHandler,
    });
  }

  render() {
    return (
      <div>
        <div id="howToGet">
          <div
            className={
              this.state.isMobile ? 'how-to-get container' : 'how-to-get '
            }
          >
            <Fade bottom>
              <div className="how-to-get-form">
                <div
                  id="howToGetID"
                  className={this.state.isMobile ? '' : 'container p-0 p-lg-3'}
                >
                  <div className="row titleHowToGet">
                    <div className="col-lg-8 col-md-12 col-sm-12 ">
                      <h4 className="how-to-get-header">
                        {lang.WHO_CAN_GET_TITLE[this.props.language]}
                      </h4>
                      <div className="how-to-get-description mobile-text-version pl-0">
                        {lang.WHO_CAN_GET_DESCRIPTION[this.props.language]}
                      </div>
                    </div>
                  </div>
                  <div className="row imageFormDiv">
                    <div className=" howToGetImagesOrder col-lg-3 p-lg-0 d-flex col-md-6 mb-md-3 mb-sm-5 col-sm-12">
                      <div>
                        <img
                          src={reasonSick}
                          className="reason-imgs-1"
                          alt="reason"
                        />
                      </div>
                      <span>
                      {lang.WHO_CAN_GET_REASON_1[this.props.language]} <br />
                      {lang.WHO_CAN_GET_REASON_1_1[this.props.language]}{' '}
                        <br />
                        {' '}
                        <br />
                      </span>
                    </div>


                    <div className=" howToGetImagesOrder col-lg-3 p-lg-0 d-flex col-md-6 mb-md-3 mb-sm-5 col-sm-12">
                      <div>
                        <img
                          src={reasonAccident}
                          className="reason-imgs-2"
                          alt="reason"
                        />
                      </div>
                      <span>
                        {lang.WHO_CAN_GET_REASON_2[this.props.language]} <br />
                        {lang.WHO_CAN_GET_REASON_2_1[this.props.language]}{' '}
                        <br />
                        {lang.WHO_CAN_GET_REASON_2_2[this.props.language]}{' '}
                        <br />
                      </span>
                    </div>

                    <div className="howToGetImagesOrder col-lg-3 p-lg-0 d-flex col-md-6 mb-md-3 mb-sm-5 col-sm-12">
                      <div>
                        <img
                          src={reasonBusiness}
                          className="reason-imgs-3"
                          alt="reason"
                        />
                      </div>
                      <span>
                        {lang.WHO_CAN_GET_REASON_3[this.props.language]} <br />
                        {lang.WHO_CAN_GET_REASON_3_1[this.props.language]}{' '}
                        <br />
                        {lang.WHO_CAN_GET_REASON_3_2[this.props.language]}{' '}
                        <br />
                      </span>
                    </div>
                    <div className="howToGetImagesOrder col-lg-3 p-lg-0 d-flex col-md-6 mb-md-3 mb-sm-5 col-sm-12">
                      <div>
                        <img
                          src={reasonVocation}
                          className="reason-imgs-4"
                          alt="reason"
                        />
                      </div>
                      <span>
                        {lang.WHO_CAN_GET_REASON_4[this.props.language]} <br />
                        {lang.WHO_CAN_GET_REASON_4_1[this.props.language]}{' '}
                        <br />
                        {lang.WHO_CAN_GET_REASON_3_2[this.props.language]}{' '}
                        <br />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </Fade>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    language: state.language.language,
  };
}

export default connect(mapStateToProps)(HowToGet);
